import { formatUrl } from "@/lib/util";
import { PropsWithChildren } from "react";

const DetailItem = ({
  title,
  children,
  ...props
}: PropsWithChildren & { title: string; itemProp?: string }) => (
  <>
    <dt className="font-bold whitespace-nowrap">{title}</dt>
    <dd className="flex justify-end text-end" {...props}>
      {children}
    </dd>
  </>
);

const Address = ({
  address: { street, zipcode, town },
}: {
  address: Partial<Travelguide.Address>;
}) => (
  <p itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
    {street && <span itemProp="streetAddress">{street}</span>}
    {street && (zipcode || town) && <br />}
    {zipcode && <span itemProp="postalCode">{zipcode}</span>}
    {zipcode && town && " "}
    {town && <span itemProp="addressLocality">{town}</span>}
  </p>
);

function isAccomodationSection(
  section:
    | Travelguide.POISection.Detail
    | Travelguide.AccomodationSection.Detail
): section is Travelguide.AccomodationSection.Detail {
  return "priceText" in section.value;
}

export const DetailSection = ({
  section,
}: {
  section:
    | Travelguide.POISection.Detail
    | Travelguide.AccomodationSection.Detail;
}) => (
  <section className="flex flex-col gap-5 w-full px-4 md:px-0">
    <h2 className="aside">Details</h2>
    <dl className="grid grid-cols-[min-content,1fr] justify-between text-list">
      {isAccomodationSection(section) && section.value.priceText && (
        <DetailItem title="Preis">{section.value.priceText}</DetailItem>
      )}
      {section.value.address && (
        <DetailItem title="Adresse">
          <Address address={section.value.address} />
        </DetailItem>
      )}
      {section.value.homepage && (
        <DetailItem title="Webseite" itemProp="url">
          <a href={section.value.homepage} target="_blank" rel="noreferrer">
            {formatUrl(section.value.homepage)}
          </a>
        </DetailItem>
      )}
      {section.value.phone && (
        <DetailItem title="Telefon" itemProp="telephone">
          {section.value.phone}
        </DetailItem>
      )}
      {section.value.email && (
        <DetailItem title="E-Mail" itemProp="email">
          <a
            href={`mailto: ${section.value.email}`}
            target="_blank"
            rel="noreferrer"
          >
            {section.value.email}
          </a>
        </DetailItem>
      )}
    </dl>
  </section>
);
